<template>
  <div class="reset-container animated fadeInUp">
    <v-flex tag="h3">
      {{ $t("view.login.resetPwd.title") }}
    </v-flex>
    <v-subheader>{{ $t("view.login.resetPwd.instructions") }}</v-subheader>
    <form @submit.prevent @keyup.enter="resetPassword">
      <!-- New Password -->
      <v-text-field
        v-model.trim="$v.auth.newpassword.$model"
        prepend-icon="lock"
        name="password"
        :disabled="view.action.resetPassword.busy"
        :error-messages="$t(`validator.${getFirstError($v.auth.newpassword)}.text`, '')"
        :label="$t('view.login.resetPwd.password.placeholder')"
        :type="show1 ? 'text' : 'password'"
        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="show1 = !show1" />

      <!-- New Password Confirmation-->
      <v-text-field
        v-model.trim="$v.auth.confirmpassword.$model"
        prepend-icon="lock"
        name="password"
        :disabled="view.action.resetPassword.busy"
        :error-messages="$t(`validator.${getFirstError($v.auth.confirmpassword)}.text`, '')"
        :label="$t('view.login.resetPwd.confirmpassword.placeholder')"
        :type="show2 ? 'text' : 'password'"
        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="show2 = !show2" />

      <label v-if="hasErrors($v.auth.confirmpassword)" class="error--text" for="password">
        {{ getConfirmPasswordErrorDescription }}
      </label>

      <div class="form-group">
        <label v-if="view.elem.label.resetPasswordError.visible" for="error" class="error--text">
          {{ errorResetPasswordMessage }}
        </label>
        <v-btn :disabled="hasErrors($v.auth) || view.action.resetPassword.busy" name="loginSubmit" block color="primary" @click="resetPassword()">
          {{ $t("view.login.resetPwd.submit") }}
        </v-btn>
      </div>
    </form>
  </div>
</template>
<script>
import Auth from "@/services/auth";
import transform from "@/helpers/transformations";
import * as actions from "@/constants/mutation-names";
import { valueIsWithin } from "@/helpers/validators";
import { AuthenticationModel } from "@/models/authentication";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { required, sameAs } from "vuelidate/lib/validators";

const label = {
  resetPasswordError: {
    visible: false
    , text: ""
  }
};
const button = { resetPassword: { enable: true } };

const action = { resetPassword: { busy: false } };

export default {
  name: "ResetPasswordModule"
  , data() {
    return {
      auth: undefined
      , token: undefined
      , show1: false
      , show2: false
      , view: {
        title: this.$t("view.login.forgetPwd.title")
        , action
        , elem: {
          label
          , button
        }
      }
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , computed: {
    errorResetPasswordMessage() {
      return this.view.elem.label.resetPasswordError.text;
    }
    , getConfirmPasswordErrorDescription() {
      const samePass = () => {
        return this.$t("view.login.forgetPwd.samePass");
      };
      return this.getFirstErrorDescription(this.$v.auth.confirmpassword, { samePass });
    }
  }
  , created() {
    if (this.$route.query.token) {
      this.token = this.$route.query.token;
      this.setInitialState();
    } else {
      this.$router.push("/401Unauthorized");
    }
  }
  , methods: {
    ...allValidatorMethods
    , async resetPassword() {
      try {
        // Hide any previous error
        this.hideErrorResetPassword();
        // Validate all models before make the request
        if (!this.isAllValid(this.$v)) {
          return;
        }
        // Gettin data to submit
        const { newpassword, confirmpassword } = this.auth;
        const { token } = this;
        this.view.action.resetPassword.busy = true;
        const response = await Auth.resetPassword({ newpassword, confirmpassword, token });
        this.view.action.resetPassword.busy = false;
        // Gettin data from response
        let { data: { results: { token: userToken, usuario, roles } } } = response;
        const data = { ...transform.ResponseToUserStore(usuario), userToken, roles };
        this.$store.dispatch(actions.AUTH_LOGIN, data);
        this.$userPermission.set({ roles });
        this.$router.push("/home");
      } catch (error) {
        this.view.action.resetPassword.busy = false;

        if (error && (error.status == "500" || error.status == "504")) {
          this.showErrorResetPassword(this.$t(`errors.network..${error.status}.desc`));
          return;
        }

        const login = this.$t("view.login");

        // List of errors required for changing password flow
        const errorsResetPassword = Object.keys(login.resetPassword);
        const errorsChangePassword = Object.keys(login.changePassword);

        const { data: { meta: { code: errorCode } } } = error;
        // Error's reseting password
        if (valueIsWithin(errorsResetPassword, errorCode)) this.showErrorResetPassword(this.$t(`view.login.resetPassword.${errorCode}.text`));
        // Error's reseting password
        if (valueIsWithin(errorsChangePassword, errorCode)) this.showErrorResetPassword(this.$t(`view.login.changePassword.${errorCode}.text`));
      }
    }
    , showErrorResetPassword(message) {
      this.view.elem.label.resetPasswordError.visible = true;
      this.view.elem.label.resetPasswordError.text = message;
    }
    , hideErrorResetPassword() {
      if (!this.view.elem.label.resetPasswordError.visible) return;
      this.view.elem.label.resetPasswordError.visible = false;
      this.view.elem.label.resetPasswordError.text = "";
    }
    , setInitialState() {
      this.auth = new AuthenticationModel();
      this.view.elem.label.resetPasswordError.visible = false;
      this.view.elem.label.resetPasswordError.text = "";
    }
  }
  , validations: {
    auth: {
      newpassword: { required }
      , confirmpassword: {
        required
        , sameAs: sameAs("newpassword")
      }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.reset-container {
  position: relative;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/ResetPassword.vue